<template>
  <a-spin :spinning="formOption.busy">
    <div class="big_box" v-if="exhibition">

      <div class="medium_box fix">
        <div class="left_box l fix">
          <div class="left_small_box l"><img :src="entityForm.avatar|fileWxPath" alt=""></div>
          <div class="right_small_box l">
            <div class="btn_box">
              <div class="l" style="margin: 0 8px;font-weight: bold;">{{ entityForm.custName }}</div>
              <a-button class="a_btn_box l" v-if="entityForm.wantLevelName">{{ entityForm.wantLevelName }}</a-button>
            </div>
<!--            客户标签 2023/02/16  报错处理-->
<!--            <div class="btn_box">-->
<!--              <template v-if="entityForm.tagList && entityForm.tagList.length > 0">-->
<!--                <a-tag v-for="(item, index) in entityForm.tagList[0].tagNameList.filter((item,index) => index < 3)"-->
<!--                       :key="index" :color="item.tagTypeId === 2 ? `blue` : `red`">-->
<!--                  {{ item.tagName }}-->
<!--                </a-tag>-->
<!--              </template>-->
<!--              <a-popover placement="bottom" trigger="click" :title="null">-->
<!--                <template slot="content">-->
<!--                  <p v-for="item in entityForm.tagList" :key="item.userId" style="width: 600px">-->
<!--                    <a-avatar :src="item.headImg"/>-->
<!--                    {{ item.userName }}:-->
<!--                    <a-tag v-for="tag in item.tagNameList" :key="tag.custTagId"-->
<!--                           :color="tag.tagTypeId === 2 ? `blue` : `red`">-->
<!--                      {{ tag.tagName }}-->
<!--                    </a-tag>-->
<!--                  </p>-->
<!--                </template>-->
<!--                <a-tag v-if="entityForm.tagList && entityForm.tagList.length > 1">···</a-tag>-->
<!--              </a-popover>-->
<!--            </div>-->
          </div>
        </div>
        <div class="right_box r fix">
          <div class="l" v-if="false">电话</div>
          <div class="l wechat" v-if="false">企微</div>
          <a-button class="r" @click="compile">编辑</a-button>
        </div>
      </div>
    </div>

    <div class="nav_info_box">
      <div class="info_item" style="width: 175px;">
        <span class="name"><a-icon type="home"/>&nbsp;企业</span>
        <span class="value el">{{ entityForm.companyName ? entityForm.companyName : '暂无信息' }}</span>
      </div>
      <div class="info_item">
        <span class="name"><a-icon type="mobile"/>&nbsp;电话</span>
        <span class="value">{{ entityForm.telephone ? entityForm.telephone : '暂无信息' }}</span>
      </div>
      <div class="info_item" v-if="entityForm.followUserInfo">
        <span class="name"><a-icon type="user"/>&nbsp;跟进人</span>
        <span class="value"><img class="header" v-if="entityForm.followUserInfo"
                                 :src="entityForm.followUserInfo.headImg" alt=""></span>
        <!--        <span class="value">{{entityForm.followUserInfo.followUserName}}</span>-->
      </div>
      <div class="info_item" v-if="imgList.length>0">
        <span class="name"><a-icon type="user"/>&nbsp;共享人</span>
        <span class="value more">
          <img class="header" v-for="(item, index) in imgList" :key="index" :src="item.headImg" alt="">
        </span>
      </div>
      <div class="info_item" v-if="entityForm.dealChance">
        <span class="name"><a-icon type="pie-chart"/>&nbsp;成交概率</span>
        <span class="value">{{ entityForm.dealChance }}</span>
      </div>
    </div>

    <!--    切换nav start-->
    <div class="content_box fix" v-if="exhibition">
      <div class="content_small_box "
           @click="change(1)"
           :class="{active: index===1}"
      >联系人资料
      </div>
      <div class="content_small_box "
           @click="change(2)"
           :class="{active: index===2}"
      >成交记录
      </div>
      <div class="content_small_box "
           @click="change(3)"
           :class="{active: index===3}"
      >跟进记录
      </div>

      <div class="content_small_box"
           @click="change(4)"
           :class="{active: index===4}"
      >操作日志
      </div>
      <div class="content_small_box"
           @click="change(5)"
           :class="{active: index===5}"
      >客户轨迹
      </div>
      <!--      todo 保有车辆  等接口 -->
      <div class="content_small_box"
           @click="change(6)"
           :class="{active: index===6}"
      >保有车辆
      </div>
    </div>
    <!--    切换nav end-->

    <div v-show="index===1">
      <a-form style="padding: 0 15px;" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 7 }"
              @submit="handleSubmit" point-events="false">
        <div class="info_box" @click="fold" v-html="have===1 ? '▶ 基本信息' : '▼ 基本信息'"></div>
        <div v-show="have===2">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="客户名称">
                <a-input
                    v-decorator="['custName', { rules: [{ required: true, message: '请输入姓名' }] }]"
                    :disabled="show"
                    placeholder="请输入姓名"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="公司名称">
                <a-input
                    placeholder="请输入公司名称"
                    v-decorator="['companyName', { rules: [{ required: custCategoryId > 30003001 , message: '请输入公司名称' }] }]"
                    :disabled="show"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="手机号">
                <a-input
                    v-decorator="['telephone', { rules: [{ required: true, message: '请输入手机号' }] }]"
                    :disabled="show"
                    placeholder="请输入手机号"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="客户性别">
                <a-radio-group @change="onChange" :disabled="show"
                               v-decorator="['sex', { rules: [{ required: true, message: '请选择性别' }] }]">
                  <a-radio :value="1">
                    男
                  </a-radio>
                  <a-radio :value="0">
                    女
                  </a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="出生日期">
                <a-date-picker @change="onChangeDate"
                               v-decorator="['birthday', { rules: [{ required: false, message: '' }] }]"
                               :disabled="show"
                               value-format="YYYY-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="民族">
                <a-select
                    style="width: 250px"
                    v-decorator="['nationId']"
                    :disabled="show"
                    :options="nation"
                    @change="handleChange6"
                >
                </a-select>
              </a-form-item>
            </a-col>
          <!-- qf05 -->
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="身份证号">
                <a-input
                    v-decorator="['idCard', { rules: [{ required: true, message: '请输入身份证号码' }] }]"
                    :disabled="show"
                    :max-length="18"
                    placeholder="请输入身份证号"
                    @input="handleIdCardChange"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="社会统一信用代码">
                <a-input
                    v-decorator="['uscCode', { rules: [{ required: false, message: '' }] }]"
                    :max-length="20"
                    :disabled="show"
                    placeholder="请输入社会统一信用代码"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="省市区">
                <a-cascader v-decorator="['mbrAreaList']"
                            placeholder="请选择所在区域"
                            :options="treeData"
                            :fieldNames="{ label: 'areaName', value: 'areaId', children: 'children' }"
                            :disabled="show"
                            @change="handleChange7"
                />
              </a-form-item>
            </a-col>
          </a-row>
                    <!-- qf06 -->
                    <!-- v-decorator="['address', { rules: [{ required: false, message: '' }] }]" -->

          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="详细地址">
                <a-input
                v-decorator="['address', { rules: [{ required: true, message: '请输入详情地址' }] }]"
                :disabled="show"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24" style="margin:5px 0 15px 0;font-weight: bold;font-size: 15px">
            重要标签
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="客户类型">
                <a-select
                    v-decorator="['custCategoryId', { rules: [{ required: true, message: '请选择客户类型' }] },{initialValue: '1'}]"
                    style="width: 250px" @change="handleChange" :disabled="show"
                    :options="customerType">
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="客户性质">
                <a-select
                    v-decorator="['custNatureId', { rules: [{ required: true, message: '请选择客户性质' }] },{initialValue: '1'}]"
                    style="width: 250px" @change="handleChange3" :disabled="show"
                    :options="customerProperty">
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="所属细分行业">
                <a-select
                    v-decorator="['industryId', { rules: [{ required: true, message: '请选择细分行业' }] },{initialValue: '1'}]"
                    style="width: 250px" :disabled="show" @change="handleChange4"
                    :options="subdividedTradeStructure">
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="客户信息来源">
                <a-select
                    v-decorator="['sourceId',{ rules: [{ required: true, message: '请选择客户来源' }] },{initialValue: '1'},]"
                    style="width: 250px" @change="handleChange1" :disabled="show"
                    :options="customerSource">
                </a-select>
              </a-form-item>
            </a-col>

          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="意向品系">
                <a-select
                    v-decorator="['wantStrainId',{ rules: [{ required: true, message: '请选择意向品系' }] },{initialValue: '1'},]"
                    style="width: 250px" @change="handleChangeStarin" :disabled="show"
                    :options="wantStrainOption">
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="了解柳汽主要渠道">
                <a-select
                    v-decorator="['learnTypeId',{ rules: [{ required: true, message: '请选择了解到柳汽的方式' }] }]"
                    style="width: 250px"
                    :options="understand"
                    :disabled="show"
                    placeholder="请选择了解到柳汽的方式"
                    @change="handleChange5"
                >
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="是否向厂家进行组织客户报备">
                <a-radio-group
                    v-decorator="['isReport', { rules: [{ required: true, message: '请选择是否报备' }] }]"
                    @change="onChange" :disabled="show">
                  <a-radio :value="1">
                    是
                  </a-radio>
                  <a-radio :value="0">
                    否
                  </a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="最近意向等级">
                <a-input
                    v-decorator="['lastWantLevelName']"
                    :disabled="true"
                />
              </a-form-item>
            </a-col>

            <a-col :span="12">
              <a-form-item label="最近跟进时间">
                <a-input
                    v-decorator="['lastFollowDate']"
                    :disabled="true"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="最近购买时间">
                <a-input
                    v-decorator="['lastBuyDate']"
                    :disabled="true"
                />
              </a-form-item>
            </a-col>

          </a-row>
          <template v-if="entityForm.sourceName === '转介绍' || sourceId === 30001004">
            <a-row :gutter="24" style="margin:5px 0 15px 0;font-weight: bold;font-size: 15px">
              转介绍人
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item label="姓名">
                  <a-input
                      v-decorator="['introducer', { rules: [{ required: false, message: '请输入转介绍人姓名' }] }]"
                      :disabled="show"
                      placeholder="请输入姓名"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="手机">
                  <a-input
                      v-decorator="['introducerPhone', { rules: [{ required: false, message: '请输入转介绍人手机' }] }]"
                      :disabled="show"
                      placeholder="请输入手机"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </template>

          <!--          <a-row :gutter="24">-->

          <!--            <a-col :span="12">-->
          <!--              <a-form-item label="客户描述">-->
          <!--                <a-input-->
          <!--                    v-decorator="['remark', { rules: [{ required: false, message: '' }] }]"-->
          <!--                    :disabled="show"-->
          <!--                    placeholder="请具体对客户进行描述~"-->
          <!--                />-->
          <!--              </a-form-item>-->
          <!--            </a-col>-->
          <!--          </a-row>-->
        </div>
        <div v-show="false" class="info_box" @click="foldTwo" v-html="has===1 ? '▶ 系统信息' : '▼ 系统信息'"></div>
        <!--      <a-form style="margin-top: 8px" v-show="has===2" :form="infoForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 7 }">-->
        <div v-show="false">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="最近联系时间">
                <a-input disabled class="a_input"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="创建时间">
                <a-input disabled class="a_input"
                         v-decorator="['createDate', { rules: [{ required: false, message: 'Please input your note!' }] }]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="好友来源">
                <a-input disabled class="a_input"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="系统来源">
                <a-input disabled class="a_input"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="联系人编号">
                <a-input disabled class="a_input"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="联系人添加时间">
                <a-input disabled class="a_input"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="获取联系人时间">
                <a-input disabled class="a_input"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-form>
    </div>
    <div v-show="index===2" class="two_box">
      <div v-if="!dealRecordList || dealRecordList.length < 1" style="text-align: center">暂无数据~</div>
      <div class="transaction" v-for="(item, index) in dealRecordList" :key="index" v-else>
        <div class="transaction_word">品系：{{ item.strainName }}</div>
        <div class="transaction_word">车辆类别：{{ item.carType }}</div>
        <div class="transaction_word">车型：{{ item.carModel }}</div>
        <div class="transaction_word">底盘号：{{ item.vin }}</div>
        <div class="transaction_word">驱动形式：{{ item.driverModel }}</div>
        <div class="transaction_word">订车时间：{{ item.estimateBuyDate }}</div>
        <div class="transaction_word">订车数量：{{ item.buyCount }}</div>
      </div>
    </div>
    <!--    todo /BUSSINESS-SERVE/scrm/saleCust/detail/470  followRecordList 缺少头像-->
    <div v-show="index===3">
      <div v-if="!followRecordList || followRecordList.length < 1" style="text-align: center;margin-top: 11px">暂无数据~
      </div>
      <div class="follow_up_box">
        <div class="follow_up_small_box" v-for="(item, index) in followRecordList" :key="index">
          <div class="follow_up_word fix">
            <div class="follow_up_img l" v-if="item.avatar">
              <img :src="item.avatar" alt="">
            </div>
            <div class="l">
              <div class="follow_up_name">{{ item.custName }}</div>
              <div> {{ item.createDate }}</div>
            </div>
          </div>
          <div style="margin-bottom: 8px">具体跟进内容：{{ item.reportDesc }}</div>
          <div>跟进类型：{{ item.reportTypeName }}</div>
        </div>
      </div>
    </div>
    <div v-show="index===4">
      <operationLog :operationLogList="operationLogList"></operationLog>
    </div>
    <div v-show="index===5">
      <customerTrail :customerTrailList="customerTrailList"></customerTrail>
    </div>
    <div v-show="index===6">
      <vehicleOwnership :vehicleOwnershipList="vehicleOwnershipList"></vehicleOwnership>
    </div>

    <a-space class="a-form-btn-box" v-if="!show">
      <a-button @click="endEdit('cancelled')">取消</a-button>
      <a-button type="primary" @click="_save(false)">提交</a-button>
    </a-space>
  </a-spin>
</template>

<script>
// import {formMixin} from "@/utils/FormMixin";
// import {formatter as fmt} from "@/utils/form-formatter";
import {formMixin, fmt} from '@/utils/common/FormBase'
//通用代码api
import {loadAreaTreeCasData, loadBaseCodeData, dealTreeNoChild} from '@/services/baseCodeSource';


console.log(loadBaseCodeData)

//接口API
import {dataApi} from '@/services/client/customer';
import operationLog from './detail/operationLog.vue';
import vehicleOwnership from './detail/vehicleOwnership.vue';
import customerTrail from './detail/customerTrail.vue';


// import roleTable from "@/pages/web/comm/userManage/detail/roleTable";
import {mapState} from "vuex";
import api from "@/services/api";

// import XEUtils from "xe-utils";

/**
 * 加载规则
 */
// function getRulesTemplate() {
//   return {
//     userNo: {
//       rules: [{required: true, message: "请输入用户账号"}]
//     },
//     userName: {
//       rules: [{required: true, message: "请输入用户名称"}]
//     },
//     remark: {
//       rules: [{required: false, max: 255, message: "备注长度不能超过255"}]
//     },
//     deptId:{
//       rules: [{required: true, message: "请选择所属部门"}]
//     },
//     phone:{
//       rules:[{
//         required: false,
//         trigger: "blur"
//       },
//         {
//           validator: function(rule, value, callback) {
//             if (value !=null && value !=="" &&
//                 /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
//                 .test(value) == false) {
//               callback(new Error("手机号格式错误"));
//             } else {
//               callback();
//             }
//           },
//           trigger: "blur"
//         }]
//     },
//     email: {
//       rules:[{
//         required: false,
//         trigger: "blur"
//       },
//         {
//           validator: function(rule, value, callback) {
//             if (value !=null && value !=="" &&
//                 /^[A-Za-z0-9-._]+@[A-Za-z0-9-]+(.[A-Za-z0-9]+)*(.[A-Za-z]{2,6})$/i.test(
//                     value
//                 ) == false
//             ) {
//               callback(new Error("邮箱格式错误"));
//             } else {
//               callback();
//             }
//           },
//           trigger: "blur"
//         }
//       ]}
//   };
// }


function begin() {
  if (this.rowId) {
    this.exhibition = true
  } else {
    this.exhibition = false
    this.have = 2
    this.show = false;
  }
}

/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad(entity) {
  console.log(entity)
  if (entity.provinceId) {
    this.setFormValue({
      'mbrAreaList': [entity.provinceId, entity.cityId, entity.districtId]
    })
  }

}

/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {}
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {

  let entity = await dataApi.getFormDetail(rowId);
  this.entityForm = entity.data
  this.dealRecordList = entity.data.dealRecordList
  this.followRecordList = entity.data.followRecordList
  this.operationLogList = entity.data.logs
  this.customerTrailList = entity.data.traits
  this.vehicleOwnershipList = entity.data.vehcles
  this.imgList = entity.data.shareUserList
  this.custCategoryId = entity.data.custCategoryId

  this.sourceName = entity.data.sourceName// 客户来源
  this.custCategoryName = entity.data.custCategoryName// 客户类型
  this.custNatureName = entity.data.custNatureName// 客户性质
  this.industryName = entity.data.industryName// 细分行业
  this.learnTypeName = entity.data.learnTypeName// 了解柳汽方式
  this.loyalDimensionName = entity.data.loyalDimensionName// 忠诚维度
  this.nationName = entity.data.nationName// 民族
  // this.provinceName = entity.data.provinceName
  // this.cityName = entity.data.cityName
  this.districtName = entity.data.districtName

  this.strainName = entity.data.strainName// 意向品系
  return fmt.formatFormLoad(entity);
}


/**
 * 加载基础数据
 */
async function loadBaseData() {
  this.customerType = await loadBaseCodeData('CD300003');
  this.customerProperty = await loadBaseCodeData('CD300004');
  this.subdividedTradeStructure = await loadBaseCodeData('CD300005');
  this.customerSource = await loadBaseCodeData('CD300001');
  this.understand = await loadBaseCodeData('CD300006');
  this.nation = await loadBaseCodeData('CD000002');
  this.treeData = await loadAreaTreeCasData();
  dealTreeNoChild(this.treeData)

  //品系
  this.wantStrainOption = await dataApi.selectionStrain();//品系
  this.wantStrainOption = this.wantStrainOption.data.map(v => {
    return {
      label: v.strainName,
      value: v.strainId
    }
  })

}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  console.log(entities)
  entities.sourceName = this.sourceName;

  entities.custCategoryName = this.custCategoryName// 客户类型
  entities.custNatureName = this.custNatureName// 客户性质
  entities.industryName = this.industryName// 细分行业
  entities.learnTypeName = this.learnTypeName// 了解柳汽方式
  entities.loyalDimensionName = this.loyalDimensionName// 忠诚维度
  entities.nationName = this.nationName// 民族

  entities.districtName = this.districtName

  entities.strainName = this.strainName// 意向品系

  entities.custId = vm.keyId;
  if (entities.mbrAreaList) {
    entities.provinceId = entities.mbrAreaList.split(',')[0];
    entities.cityId = entities.mbrAreaList.split(',')[1];
    entities.districtId = entities.mbrAreaList.split(',')[2];

    entities.provinceName = this.provinceName
    entities.cityName = this.cityName
    entities.districtName = this.districtName

  }
  console.log(entities)
  return await dataApi.saveFormDetail(entities);
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {
    operationLog,
    vehicleOwnership,
    customerTrail
  },
  computed: {
    ...mapState('account', {currUser: 'user'}),
  },
  data() {
    return {
      value: 1,
      index: 1,
      editStatus: false,
      treeData: [],
      dealer: [],
      infoForm: {},
      show: true,
      info: null,
      have: 2,
      has: 1,
      customerType: [],
      customerProperty: [],
      subdividedTradeStructure: [],
      customerSource: [],
      wantStrainOption: [],
      understand: [],
      dealRecordList: {},
      followRecordList: {},
      operationLogList: [],
      customerTrailList: [],
      vehicleOwnershipList: [],
      exhibition: true,
      entityForm: {},
      imgList: [],
      nation: [],
      custCategoryId: 0,
      sourceId: 0,
      sourceName: '',// 客户来源

      custCategoryName: '',// 客户类型
      custNatureName: '',// 客户性质
      industryName: '',// 细分行业
      learnTypeName: '',// 了解柳汽方式
      loyalDimensionName: '',// 忠诚维度
      nationName: '',// 民族
      provinceName: '',
      cityName: '',
      districtName: '',

      strainName: '',// 意向品系
    }
  },
  filters: {
    fileWxPath(data) {
      if (data?.includes('http')) {
        return data;
      } else {
        return api.temp.FILE_PATH + data
      }
    }
  },
  mounted() {
    this.begin();
  },
  methods: {
    begin,
    loadEntity,
    newEntity,
    save,
    // getRulesTemplate,
    loadBaseData,
    afterLoad,
    // qf07
    handleIdCardChange(e) {
      const idCard = e.target.value;
      if (idCard.length === 18) { // 仅处理18位身份证
        const birthDateStr = idCard.substring(6, 14);

        // 提取并格式化日期
        const year = birthDateStr.substring(0, 4);
        const month = birthDateStr.substring(4, 6);
        const day = birthDateStr.substring(6, 8);
        console.log("year，", year);
        console.log("month，", month);
        console.log("day，", day);
        // 简单校验月份和日期
        if (month < 1 || month > 12) return;
        if (day < 1 || day > 31) return;

        // 设置表单值
        this.form.setFieldsValue({
          birthday: `${year}-${month}-${day}`
        });
      }
    },
    handleChange7(value) {
      console.log(value);
      this.treeData.map(item => {
        console.log(item);
        console.log('value', value);
        if (item.areaId === value[0]) {
          this.provinceName = item.areaName
          console.log('这是name')
          console.log(this.provinceName);
          item.children.map(item => {
            if (item.areaId === value[1]) {
              this.cityName = item.areaName
              console.log('这是name')
              console.log(this.cityName);
              item.children.map(item => {
                if (item.areaId === value[2]) {
                  this.districtName = item.areaName
                  console.log('这是name')
                  console.log(this.districtName);
                }
              })
            }
          })
        }
      })
      this.nationId = value
    },

    handleChange6(value) {
      console.log(value);
      console.log(value)
      this.nation.map(item => {
        console.log(item);
        if (item.codeId === value) {
          this.nationName = item.codeName
          console.log(this.nationName)

        }
      })
      this.nationId = value
    },

    handleChange5(value) {
      console.log(value);
      console.log(value)
      this.understand.map(item => {
        console.log(item);
        if (item.codeId === value) {
          this.learnTypeName = item.codeName
          console.log(this.learnTypeName)

        }
      })
      this.learnTypeId = value
    },
    handleChange4(value) {
      console.log(value);
      console.log(value)
      this.subdividedTradeStructure.map(item => {
        console.log(item);
        if (item.codeId === value) {
          this.industryName = item.codeName
          console.log(this.industryName)

        }
      })
      this.industryId = value
    },
    handleChange3(value) {
      console.log(value);
      console.log(value)
      this.customerProperty.map(item => {
        console.log(item);
        if (item.codeId === value) {
          this.custNatureName = item.codeName
          console.log(this.custNatureName)

        }
      })
      this.custNatureId = value
    },
    handleChange(value) {
      console.log(value);
      console.log(value)
      this.customerType.map(item => {
        console.log(item);
        if (item.codeId === value) {
          this.custCategoryName = item.codeName
          console.log(this.custCategoryName)

        }
      })
      this.custCategoryId = value
    },
    handleChange1(value) {
      console.log(value)
      this.customerSource.map(item => {
        console.log(item);
        if (item.codeId === value) {
          this.sourceName = item.codeName
          console.log(this.sourceName)
        }
      })
      this.sourceId = value
    },
    handleChangeStarin(value) {
      //wantStrainOption
      console.log(value)
      this.wantStrainOption.map(item => {
        console.log(item);
        if (item.value === value) {
          this.strainName = item.label
          console.log(this.strainName)
        }
      })
      this.wantStrainId = value
    },
    change(index) {
      this.index = index
    },
    onChange(e) {
      console.log('radio checked', e.target.value);
    },
    handleSubmit(e) {
      console.log(e)
    },
    compile() {
      this.show = false;
      this.index = 1;
    },
    fold() {
      this.have = (this.have == 1) ? 2 : 1
    },
    foldTwo() {
      this.has = (this.has == 1) ? 2 : 1
    },
    onChangeDate(date, dateString) {
      console.log(date, dateString);
    },
  },
};
</script>

<style scoped lang="less">
.nav_info_box {
  display: flex;
  justify-content: space-around;
  border-top: 1px solid #e1e1e1;
  border-bottom: 1px solid #e1e1e1;
  padding: 18px 0;

  .info_item {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .name {
      color: #333;
      font-size: 18px;
      text-align: center;
      font-weight: bold;
    }

    .value {
      color: #999;
      font-size: 16px;
      text-align: center;
      height: 30px;
      line-height: 36px;

      &.more {
        display: flex;
        justify-content: space-around;
      }

      .header {
        width: 30px;
        height: 30px;
        margin: 0 3px;
        border: 1px solid #e1e1e1;
      }
    }
  }
}


/deep/ .ant-modal-content > .ant-modal-body {
  padding: 0 !important;
}

/deep/ .ant-modal {
  width: 1040px !important;
}

.big_box {
  padding: 26px 0;
}

.left_small_box {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.left_box {
  width: 90%;
}

.right_box {
  line-height: 32px;
  margin-top: 18px;
}

.wechat {
  margin: 0 20px;
}

.right_small_box {
  width: 80%;
  height: 55px;
  padding-left: 10px;
}

.btn_box {
  width: 80%;
  height: 50%;
}

.a_btn_box {
  height: 24px;
  border-radius: 5px;
  padding: 0 5px;
  margin-right: 5px;
}

.word_box p {
  margin-top: 0;
}

.img_box_one {
  width: 27px !important;
}

.img_box {
  width: 14px;
  height: 27px;
  overflow: hidden;

  img {
    width: 27px;
    height: 27px;
  }
}

.sel_box {
  margin-top: 15px;
  padding-bottom: 30px;
  border-bottom: 1px solid #ccc;
}

.color_box {
  color: #6f718a;
  font-weight: 800;
}

.content_box {
  height: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-bottom: 1px solid #e1e1e1;

  .content_small_box {
    font-size: 18px;
    line-height: 46px;
    cursor: pointer;
    font-weight: bold;

    &.active {
      color: #009cff;
      border-bottom: 3px solid #009cff;
    }
  }
}

.info_box {
  border-bottom: 1px solid #ccc;
  padding-left: 5px;
  font-size: 15px;
  font-weight: bold;
  height: 60px;
  line-height: 60px;
  cursor: pointer;
  margin-bottom: 8px;
}

.num_box {
  color: #009cff;
  font-weight: 600;
}

/deep/ .ant-collapse {
  border: none;
}

/deep/ .ant-collapse > .ant-collapse-item {
  border: none;
}

/deep/ .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  background-color: #fff;
}

/deep/ .ant-collapse-content > .ant-collapse-content-box {
  padding: 10px;
}

/deep/ .ant-form {
  padding: 0;
}

/deep/ .ant-col-5 {
  text-align: left;
  text-overflow: ellipsis; /* 加上，显示省略号*/
  white-space: nowrap;
  overflow: hidden;
  z-index: 100;

}

/deep/ .ant-col-5:hover {
  /* 鼠标滑过  显示隐藏的内容  伴有横向的滚动条 */
  //overflow: auto;
  text-overflow: clip;
}

/deep/ .ant-input {
  width: 250px;
  padding-left: 15px !important;
}

.two_box {
  padding: 15px;
}

.transaction {
  padding: 8px 0 4px 12px;
  background-color: #f6f6f6;
}

.transaction_word {
  margin-bottom: 6px;
}

.follow_up_box {
  padding: 0 15px;
}

.follow_up_word {
  margin-bottom: 8px;
}

.follow_up_img {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: 1px solid #e1e1e1;
  margin-right: 10px;
}

.follow_up_name {
  margin: 6px 0 1px 0;
  font-weight: 800;
}

.follow_up_small_box {
  border-bottom: 1px solid #cccccc;
  padding: 12px 0 26px 0;
}

/deep/ .ant-input[disabled] {
  background-color: #fff !important;
  pointer-events: none;
}

.a_input {
  border: none;
}

/deep/ .ant-select-disabled .ant-select-selection {
  background-color: #fff;
  pointer-events: none;
}

/deep/ .ant-calendar-picker-icon {
  right: -102px !important;
}

.ant-calendar-picker-clear > .ant-calendar-picker-icon {
  right: -95px !important;
}

/deep/ .ant-form-item {
  margin-bottom: 9px;
}

/deep/ .ant-cascader-picker-arrow {
  right: -101px !important;
}

/deep/ .ant-cascader-picker-label {
  width: 200px;
}

/deep/ .ant-cascader-picker-clear {
  right: -80px !important;
}

/deep/ .ant-form-item .ant-form-explain {
  bottom: -15px !important;
}

/deep/ .ant-popover-inner-content {
  padding: 0 !important;
  display: none;
}

</style>
